import "@/react/components/HelpWidget/assets/styles/thinking-card.css";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface ThinkingCardProps {
  show?: boolean;
  title: string | null;
}

export const ThinkingCard = ({ show = true, title }: ThinkingCardProps) =>
  show ? (
    <div className="mt-4">
      <div
        id="copilot-thinking-card"
        className="bg-primary animate-slide-in flex items-start gap-1 rounded-2xl border border-[#E4E7EB] px-4 py-3 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] transition-all duration-300 dark:border-[#42464D]"
      >
        <Icon
          type="20-hw-copilot-thinking-star"
          size={20}
          className="animate-spin-clock-wise"
        />

        <span className="shimmer-text">
          <Typography.LabelSm weight="medium">{title ?? ""}</Typography.LabelSm>
        </span>
      </div>
    </div>
  ) : null;
